// Main email template router - imports from individual template files
import { generateAmandaAnalysis } from '../templates/amandaAnalysis';
import { generateAlexanderReply } from '../templates/alexanderReply';
import { generateArtistOutreach } from '../templates/artistOutreach';
import { generateFollowUp } from '../templates/followUpSequence';

export const generateEmailContent = (type, artistData, followUpNumber = 1) => {
  switch(type) {
    case 'amanda':
      return generateAmandaAnalysis(artistData);
      
    case 'alexander_reply':
      return generateAlexanderReply(artistData);
      
    case 'artist_outreach':
      return generateArtistOutreach(artistData);
      
    case 'follow_up':
      return generateFollowUp(artistData, followUpNumber);
      
    default:
      return { 
        subject: '', 
        content: '', 
        from: '', 
        to: '' 
      };
  }
};